import { AboutScreen } from './worlds/AboutScreen';
import { soundManager } from './worlds/SoundManager';
import { LevelSelectScreen } from './worlds/LevelSelectScreen';
import { GameCover } from './worlds/GameCover';
import { FW, Framework } from './framework/Framework';
import { MainCover } from './worlds/MainCover';
import { importWorldXML } from './data/WorldInfo';
import { AppBase } from './app.base';

declare const $: any;

class App extends AppBase {

    constructor() {
        super();
        FW.gafManager.addGafToLoad('worlds', 'assets/gaf');
        FW.gafManager.addGafToLoad('popups', 'assets/gaf');
        FW.addPreloadResource('worlds.xml', 'assets/xml/worlds.xml');
        FW.initialize(720, 405, false);
        FW.renderer.view.style.opacity = '0';
        FW.stage.interactiveChildren = false;
        FW.once(Framework.EVENT.PRELOAD_COMPLETE, this.onAssetsLoaded, this);
        this.reset();

        FW.on(Framework.EVENT.STAGE_RESIZE, this.refreshKidSafeBadge, this);
        this.refreshKidSafeBadge();

    }

    refreshKidSafeBadge() {
        let p = FW.stagePointToScreen(0, 0);
        $('.kidsafe').css('right', (p.x + 30) + 'px');
        $('.kidsafe').css('bottom', (p.y + 20) + 'px');
    }
    

    onAssetsLoaded() {
        this.showCover();
        FW.addUpdateFunction(this, this.fadeInUpdate);
        importWorldXML(FW.getPreloadedResource('worlds.xml').data);
        soundManager.importSoundXML(FW.getPreloadedResource('worlds.xml').data);
    }

    private fadeInUpdate(dt:number):void {
        let timePassed:number = new Date().getTime() - window['pageStartTime'];
        if(timePassed < 3000) {
            return;
        }
        var opacity:number = parseFloat(FW.renderer.view.style.opacity);
        opacity = Math.min(1, opacity + dt * 0.01);
        FW.renderer.view.style.opacity = '' + opacity;
        if(opacity == 1) {
            FW.stage.interactiveChildren = true;
            FW.removeUpdateFunction(this, this.fadeInUpdate);
        }
    }

    
    public showAbout():void {
        this.reset();
        new AboutScreen();
    }

    public showCover():void {
        this.reset();
        new MainCover();
    }

    public showGameCover():void {
        this.reset();
        new GameCover();
    }

    public enterWorld(_code:string):void {
        if(_code) {
            this.reset();
            new LevelSelectScreen({
                code: _code
            });
        }
    }

}
export const app: App = new App();


// WEBPACK FOOTER //
// ./src/app.world.ts